<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Ordenes de Despacho</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <inertia-link class="btn-indigo" :href="route('ordenes.create')">
        <span>Agregar</span>
        <span class="hidden md:inline">Orden</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nº</th>
          <th class="px-6 pt-6 pb-4">Conductor</th>
          <th class="px-6 pt-6 pb-4">Placa</th>
          <th class="px-6 pt-6 pb-4">Material</th>
          <th class="px-6 pt-6 pb-4">Capacidad</th>
          <th class="px-6 pt-6 pb-4">Destino</th>
            <th class="px-6 pt-6 pb-4">Proveedor</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Observación</th>
        </tr>
        <tr v-for="orden in ordenes.data" :key="orden.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ordenes.edit', orden.id)">
              {{ orden.id }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ordenes.edit', orden.id)">
              {{ orden.operador }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('ordenes.edit', orden.id)">
              {{ orden.placa }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
                {{ orden.material }}
            </inertia-link>
          </td>
         
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
              {{ orden.capacidad }}
            </inertia-link>
          </td>
            <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
              {{ orden.proyecto }}
            </inertia-link>
          </td>
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
              {{ orden.proveedor }}
            </inertia-link>
          </td>
            <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
              {{ orden.observaciones }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('ordenes.edit', orden.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="ordenes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Ordenes</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="ordenes.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  metaInfo: { title: 'Ordenes' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    ordenes: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('mina'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
